import React, { useState } from 'react'
import { toast } from 'react-toastify'
import Modal from '../../../components/Modal'
import { createSubjects, updateSubject } from '../../../components/services'
import { TOAST_CONFIG } from '../../../config/constants'

export default function AddSubjectModal({setModal,setSubjects,updateData,subjects,setUpdateData}) {
    const [name,setName] = useState(updateData && updateData.name ? updateData.name : '')
    const [progress,setProgress] = useState(false)
    const _submit = async(e)=>
    {
        e.preventDefault();
        try 
        {
            setProgress(true)
            let res;
            if(updateData)
            {
                res = await updateSubject(updateData._id,name)
                console.log('updated data',res)
                let index = subjects.findIndex(i=>i._id === updateData._id)
                setSubjects(prev=>
                    {
                        let newData= [...prev]
                        newData[index] = res
                        return newData
                    })
                    setUpdateData(false)
            }
            else
            {
                res = await createSubjects(name)
                console.log('received data',res)
                setSubjects(prev=>([...prev,res]))
            }
            setProgress(false)
            setModal(false)

        } catch (error) {
            setProgress(false)
            toast.error(error,TOAST_CONFIG)
        }
    }

    const _cancel = ()=>
    {
        setUpdateData(false)
        setModal(false)
    }
  return (
    <Modal title={updateData ? 'Update Subject' : 'Add Subject'} size="md">
        <form onSubmit={_submit}>
        <div className="modal-inner-content">
            <div className="input-group">
                <label>Enter Subject Name</label>
                <input type="text" className="text-input" required value={name} onChange={(e)=>setName(e.target.value)}/>
            </div>
        </div>
        <div className="modal-footer">
            <input type="button" value="Cancel" className="xs-neutral-btn" onClick={_cancel}/>
            <input type="submit" className="xs-delete-btn" disabled={progress} value={updateData ? 'Update Subject' : 'Add Subject'}/>
        </div>
        </form>
    </Modal>
  )
}
